<app-dialog [hideClose]="hideClose" class="save-scenario-excel-dialog">
  <ng-container dialog-title>
    <label class="title">{{ 'module.modals.saveScenarioExcel.saveScenarioExcelTitle' | translate }}</label>
  </ng-container>

  <ng-container dialog-content>
    <p class="description">{{ description }}</p>
  </ng-container>

  <ng-container dialog-actions>
    <button class="btn btn-outline-primary" (click)="save()">
      <span class="fa fa-file-excel-o"></span>{{ 'module.modals.saveScenarioExcel.downloadFooterButtonText' | translate }}
    </button>
    <button class="btn btn-outline-secondary" (click)="exit()">
      {{ 'module.modals.saveScenarioExcel.stopFooterDangerButtonText' | translate }}
    </button>
  </ng-container>
</app-dialog>
